import React from 'react';
import { Route, Routes } from 'react-router-dom';
import BarcodeConfigurationSettingsPane from './BarcodeConfigurations/BarcodeConfigurationSettingsPane';
import Content from '../../../components/Content';

export default function ScanningSettingsScreen({}) {
  return (
    <Content>
      <div className='flex h-full flex-col'>
        {/* <Tabs>
          <Tab
            text={t(TranslationKey.barcodeConfigurations).singular.upper}
            path={Routing.settings.scanning.barcodeConfigurations()}
            key={'barcode_configurations'}
          />
          <Tab
            text={t(TranslationKey.scanRules).singular.upper}
            path={Routing.settings.scanning.scanRules()}
            key={'scan_rules'}
          />
        </Tabs> */}

        <div className='flex-grow'>
          <Routes>
            <Route path={'barcode_configurations'} element={<BarcodeConfigurationSettingsPane />} />
            {/* <Route path={'scan_rules'} element={<ScanRulesSettingsPane />} /> */}
          </Routes>
        </div>
      </div>
    </Content>
  );
}
